import { useQuery } from "@tanstack/react-query";
import { privateApi } from "../../../api/api";
import { ProfileResponse } from "../response/ProfileResponse";

export const useGetProfileQuery = () => {
    return useQuery({
        queryKey: ['user', 'profile', 'me'],
        queryFn: async () => {
            try {
                const response = await privateApi.get('/v4/me');

                const validationResult = ProfileResponse.safeParse(response.data);
                if (!validationResult.success) {
                    console.error("Validation failed:", validationResult.error.errors);
                    throw new Error("Invalid profile data format");
                }
                return validationResult.data;

            } catch (error) {
                console.error('Failed to fetch profile', error);
                throw error;
            }
        },
        retry: import.meta.env.VITE_MAX_RETRY,
        refetchOnWindowFocus: false,
    });
};